import * as React from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ArrowDown from '../icons/arrowDown'
import ArrowMinus from '../icons/arrowMinus'

const SimpleAccordion = ({ items }) => {
  const [expanded, setExpanded] = React.useState(false)

  if (!items || items.length === 0) return null

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  // Luuakse AI ja otsingumootorite jaoks struktureeritud andmed (FAQPage Schema)
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.title,
      acceptedAnswer: {
        '@type': 'Answer',
        // Puhastatakse HTML-märgenditest puhta teksti saamiseks AI jaoks
        text: item.content ? item.content.replace(/<[^>]*>?/gm, '') : '',
      },
    })),
  }

  return (
    <div className="divide-y">
      {/* 1. See struktureeritud kood on AI-le ja otsingumootoritele koheselt loetav */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      {/* 2. Akordionid visuaalseks kuvamiseks */}
      {items.map((item, index) => {
        const panelId = `panel${index}`
        const isOpen = expanded === panelId

        return (
          <Accordion
            key={index}
            expanded={isOpen}
            onChange={handleChange(panelId)}
            // Hoiab sisu alati DOM-is (ei kaota koodist ära, kui on kinni)
            slotProps={{ transition: { unmountOnExit: false } }}
          >
            <AccordionSummary
              expandIcon={isOpen ? <ArrowMinus /> : <ArrowDown />}
              aria-controls={`${panelId}-content`}
              id={`${panelId}-header`}
            >
              <div className="accordion__title">{item.title}</div>
            </AccordionSummary>
            <AccordionDetails className="entry-content">
              <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
            </AccordionDetails>
          </Accordion>
        )
      })}
    </div>
  )
}

export default SimpleAccordion